module.exports = __webpack_public_path__ + "static/404-TOP-min-6c47624f001cebc4dbc0ad5d21b357e1.png";